import { CollectionEntity } from "@busy-human/gearbox";
export var Messages;
(function (Messages_1) {
    function MessageDefaults() {
        return {
            thread: null,
            senderId: '',
            sender: null,
            timestamp: null,
            message: '',
            from: "",
            read: false,
            commId: '',
            unitId: '',
            usersUnread: []
        };
    }
    function MessageThreadDefaults() {
        return {
            participants: null,
            timestampStarted: null,
            timestampLatestMessage: null,
            name: '',
            description: ''
        };
    }
    class CollectionClass extends CollectionEntity {
        relationships;
        defaults() {
            return MessageDefaults();
        }
    }
    Messages_1.CollectionClass = CollectionClass;
    class ThreadCollectionClass extends CollectionEntity {
        relationships;
        defaults() {
            return MessageThreadDefaults();
        }
    }
    Messages_1.ThreadCollectionClass = ThreadCollectionClass;
    Messages_1.Messages = new CollectionClass({ path: "/Messages" });
})(Messages || (Messages = {}));
//# sourceMappingURL=index.js.map